













































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { RimRepairLayoutComponent } from "@/components/common";
import InvoiceSearchFilters from "../invoices/invoice-search-filters.vue";
import { UserInterface } from "../../../utils/UserInterface";
import {
  InvoiceStatus,
  ISearchInvoicesRequest,
  IWhoAmI,
  ROLES_LIST,
} from "@/interfaces";
import { BASE_URL } from "@/plugins/axios";
import { HELPER } from "@/utils/Helper";

// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";
class pairie {
  N: string;
  V: string;
}

@Component({
  components: { RimRepairLayoutComponent, InvoiceSearchFilters },
})
export default class ReportsHomeComponent extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {
    this.Add("Type", "type");
    this.Add("Date", "date");
    this.Add("Invoice Number", "invnum");
    this.Add("Memo", "memo");
    this.Add("Customer Name", "custnam");
    this.Add("Item", "item");
    this.Add("Qty", "qty");
    this.Add("Unit Price", "uprice");
    this.Add("Subtotal", "sub");
    this.Add("Tax", "tax");
    this.Add("Invoice Total", "tot");
    this.Add("Payments", "pay");
    this.Add("Due Amount", "due");
    this.Add("Balance", "bal");

    this.SearchRequest.InvoiceStatus = [InvoiceStatus.Posted];


		/*
		IF THE USER IS NOT AN ADMIN, HE CAN GENERATE REPORTS ONLY
		FOR HIMSELF.
		*/
    var isAdmin: boolean = this.user.Roles.includes(30);
    if (!isAdmin) {
      this.SearchRequest.TechID = this.user.UserID;
      this.ShowTechDropdown = false;
    }


		this.AddExcludable("Material Charge", "MC");
		this.AddExcludable("OE Replacement", "OER");
		this.AddExcludable("Custom Color", "CC");

    // ADD HERE THE FIELDS THAT YOU WANT TO
    // HAVE SELECTED BY DEFAULT AS "FIELDS TO HIDE".
    //
    // this.ItemsSelected.push("type");
    // this.ItemsSelected.push("due");
    // this.ItemsSelected.push("bal");
    // this.ItemsSelected.push("custnam");
		this.RestoreSearch();
  }

  @Getter("user", { namespace: "AppModule" })
  public user!: IWhoAmI | null;

  public ShowTechDropdown: boolean = true;

  private Add(n: string, v: string) {
    var p = new pairie();
    p.N = n;
    p.V = v;

    this.Items.push(p);
  }

  private AddExcludable(n: string, v: string) {
    var p = new pairie();
    p.N = n;
    p.V = v;

    this.Excludables.push(p);
  }

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  // @Prop()
  public SearchRequest: ISearchInvoicesRequest = new ISearchInvoicesRequest();

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  // public Name: string = 'my name';
  public Items: pairie[] = [];
  public ItemsSelected: string[] = [];
  public ExclMaterialCharge: boolean = true;
	public Excludables: pairie[] = [];
	public ExcludablesSelected: string[] = [];

  /* VUE WATCH */
  // @Watch("value")
  // onValueChanged(newVal: any, oldVal: any) {}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* VUE METHODS */
	private PreserveSearch():void{
		HELPER.Preserve("reports-search",  {
			ItemsSelected: this.ItemsSelected,
			ExclMaterialCharge: this.ExclMaterialCharge,
			ExcludablesSelected: this.ExcludablesSelected,
			SearchRequest: this.SearchRequest,
		})
	}

	private RestoreSearch():void{
		var o = HELPER.Restore("reports-search");
		if (o==null)return;
		this.ItemsSelected = o.ItemsSelected;
		this.ExclMaterialCharge = o.ExclMaterialCharge;
		this.ExcludablesSelected = o.ExcludablesSelected;
		this.SearchRequest = o.SearchRequest;
	}

  public FiltersUpdated(): void {
		this.PreserveSearch();
  }

  public GenRepo(num: number): void {
	
		this.PreserveSearch();

    var req = {
      MinDate: this.SearchRequest.MinDate,
      MaxDate: this.SearchRequest.MaxDate,
      TechID: this.SearchRequest.TechID,
      InvStatus: this.SearchRequest.InvoiceStatus,
      HideCols: this.ItemsSelected,
      CustomerID: this.SearchRequest.CustomerID,
      ExclMaterialCharge: this.ExclMaterialCharge,
      ReportID: num,
			Excludables: this.ExcludablesSelected,
    };

    var json = JSON.stringify(req);

    window.open(BASE_URL + "?action=invoices-report&prms=" + json, "_blank");
  }
}
